<template>
<div class="form border">
    <h1>{{$lang('TITLE_SEND_EMAIL_SUCCESS')}}</h1>
    <router-link style="float: right;" :to="{name: 'home'}">{{$lang('TITLE_RETURN_INDEX')}}</router-link>
</div>
</template>

<script>
export default {

};
</script>
